function hasDisplayValue(value) {
  return value != null && typeof value === 'object' && 'displayValue' in value;
}

function getDisplayValue(value) {
  if (value != null && typeof value === 'object') {
    if ('displayValue' in value) return value.displayValue;
    if ('value' in value) return value.value;
  }
  return value;
}

/** Raw stored value. A mapped cell keeps it on `value`; a scalar is already that value. */
function getDimensionRawValue(value, rowValue) {
  if (hasDisplayValue(value)) return value.value;
  if (hasDisplayValue(rowValue)) return rowValue.value;
  return value;
}

module.exports = {
  getDisplayValue,
  getDimensionRawValue,
};
